import { ConversationList } from './ConversationList';
import { ConversationFilters } from './ConversationFilters';
import { useInboxFilters } from '../hooks/useInboxFilters';
import { useConversations } from '@/hooks/useConversations';

export function InboxLayout() {
  const { filters, setFilters, resetFilters } = useInboxFilters();

  const {
    data,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useConversations(filters);

  // Check if any non-default filters are applied
  const hasFilters =
    filters.status.length !== 2 ||
    !filters.status.includes('open') ||
    !filters.status.includes('pending') ||
    filters.assignedTo !== 'me';

  return (
    <div className="h-screen flex flex-col bg-white">
      {/* Header with inline filters */}
      <header className="px-4 py-2.5 border-b border-gray-200 bg-white flex items-center justify-between gap-4">
        <h2 className="text-sm font-semibold text-gray-900">Inbox</h2>
        <ConversationFilters filters={filters} onFiltersChange={setFilters} />
      </header>

      {/* List */}
      <div className="flex-1 overflow-hidden">
        <ConversationList
          conversations={data?.conversations ?? []}
          isLoading={isLoading}
          isError={isError}
          error={error}
          hasMore={hasNextPage ?? false}
          isLoadingMore={isFetchingNextPage}
          onLoadMore={fetchNextPage}
          onRetry={() => refetch()}
          hasFilters={hasFilters}
          onClearFilters={resetFilters}
        />
      </div>
    </div>
  );
}
